/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/* Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved. */

import { useTranslation } from 'react-i18next';

import { PortalSettingsSection } from './PortalSettingsSection';
import { FF_APP_PORTALS_INTEGRATION } from '@/shared/utils/feature-flag';

/**
 * Renders the portals integration settings, gated by the feature flag.
 *
 * @returns A disabled-state notice when the portals feature flag is off,
 * otherwise the full portal settings section.
 */
export function PortalsSection() {
  const { t } = useTranslation('features/agency-settings');

  if (!FF_APP_PORTALS_INTEGRATION) {
    return (
      <div
        style={{
          background: 'var(--surface-primary)',
          border: '1px solid var(--border-subtle)',
          borderRadius: 'var(--radius-lg)',
          padding: 'var(--space-5)',
          textAlign: 'center',
          fontSize: 'var(--text-body-sm)',
          color: 'var(--text-tertiary)',
        }}
      >
        {t('v2.portals.disabled')}
      </div>
    );
  }

  return <PortalSettingsSection />;
}
